export default "__VITE_ASSET__q4RK$PwF__";